import produce from 'immer';
import { ItemTypes } from '../constants/constants';
import { isATitleBox, isExcludedChapterTitle } from '../utils/boxes';

export const titlesActions = (set, get) => ({
  getSummaryBoxes: () => {
    const { configuration, columns, masks } = get();
    return get()
      .boxes.filter((box) =>
        [ItemTypes.TITLE, ItemTypes.TITLE_2, ItemTypes.TITLE_3, ItemTypes.TITLE_4].includes(box.type) &&
        !isExcludedChapterTitle(box, columns, masks, configuration)
      )
      .map((b) => ({
        ...b,
        text: b.content.editorState.getCurrentContent().getPlainText(),
        indexTitle: b.content.indexTitle,
      }));
  },
 unCollapseTitles: ({index}) => {
    set(
      produce((draft) => {
        draft.boxes.map((box) => {
          // Seulement les titres réellement repliés : passer `collapsed` de
          // absent à false modifiait les box, et un clic dans le Sommaire
          // écrivait en base.
          if(isATitleBox(box.type) && box?.content?.indexTitle?.[0] === index && box.collapsed) {
            box.collapsed = false;
          }
        }
        )
      }),
      false,
      `unCollapseTitles`
    );
  },
});
